import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

type Theme = 'light' | 'dark';

const THEME_STORAGE_KEY = 'cms-supplier.theme';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private themeSubject = new BehaviorSubject<Theme>(this.readInitialTheme());

  theme$ = this.themeSubject.asObservable();

  constructor() {
    this.applyTheme(this.themeSubject.value);
  }

  toggleTheme() {
    this.setTheme(this.themeSubject.value === 'light' ? 'dark' : 'light');
  }

  setTheme(theme: Theme) {
    this.themeSubject.next(theme);
    localStorage.setItem(THEME_STORAGE_KEY, theme);
    this.applyTheme(theme);
  }

  private readInitialTheme(): Theme {
    const savedTheme = localStorage.getItem(THEME_STORAGE_KEY);

    return savedTheme === 'dark' ? 'dark' : 'light';
  }

  private applyTheme(theme: Theme) {
    document.documentElement.classList.toggle('dark', theme === 'dark');
    document.body.classList.toggle('dark:bg-gray-900', theme === 'dark');
  }
}
